import {useEffect} from 'react'
import './Experience.css'
import { BsPatchCheckFill } from 'react-icons/bs'
import Aos from 'aos'
import 'aos/dist/aos.css'



const Experience = () => {

  useEffect(() => {
    Aos.init({ duration: 3000 });
  }, [])

  return (
    <section id='experience' data-aos='fade-up'>

      <h5>Skills I Have</h5>
      <h2>My Experience</h2>

      <div className='container experience_container'>

        <div className='experienced__frontend'>

          <h3>Frontend and Mobile App. Development<span className='laptop'>💻💻</span></h3>

          <div className='experience__content'>

            <article className='experience__details'>

              <BsPatchCheckFill className='experience__detail-icon' />

              <div>

              <h4>HTML</h4>
              <small className='text-light'>Experienced</small>
              </div>
              
            </article>

            <article className='experience__details'>

              <BsPatchCheckFill className='experience__detail-icon' />

              <div>
                
                <h4>CSS</h4>
              <small className='text-light'>Intermediate</small>

              </div>
              
            </article>

            <article className='experience__details'>

              <BsPatchCheckFill className='experience__detail-icon' />

              <div>

              <h4>JavaScript</h4>
              <small className='text-light'>Experienced</small>

              </div>

            </article>

            <article className='experience__details'>

              <BsPatchCheckFill className='experience__detail-icon' />

              <div>
              <h4>ReactJS</h4>
              <small className='text-light'>Experienced</small>
              </div>            

            </article>

            <article className='experience__details'>

              <BsPatchCheckFill className='experience__detail-icon' />

              <div>
              <h4>NextJS</h4>
              <small className='text-light'>Intermediate</small>
              </div>

            </article>

            <article className='experience__details'>

              <BsPatchCheckFill className='experience__detail-icon' />

              <div>
              <h4>React Native</h4>
              <small className='text-light'>Intermediate</small>
              </div>

            </article>

          </div>

        </div>

      </div>

    </section>
  )
}

export default Experience